import {OptionInterface} from "@/types/Option";

export class Option implements OptionInterface{
  text: string;
  value?: string | number | boolean;

  constructor(text: string, value: string | number | boolean) {
    this.text = text;
    this.value = value;
  }
}
